import { render, staticRenderFns } from "./DtDetailOne.vue?vue&type=template&id=03bc7457"
import script from "./DtDetailOne.vue?vue&type=script&lang=js"
export * from "./DtDetailOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports